import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { StreamingProvider } from './context/StreamingContext';
import { NotificationProvider } from './context/NotificationContext';
import { ImpersonationProvider } from './context/ImpersonationContext';
import { RequireAuth } from './components/RequireAuth';
import { ProtectedShell } from './components/ProtectedShell';
import { MainEditorView } from './components/MainEditorView';
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  VerifyEmailPage,
  AuthCallbackPage
} from './pages/auth';
import { ProfilePage } from './pages/profile/ProfilePage';
import './styles/App.css';

const ProtectedContent: React.FC = () => {
  return (
    <RequireAuth>
      <ProtectedShell>
        <MainEditorView />
      </ProtectedShell>
    </RequireAuth>
  );
};

const ProtectedProfile: React.FC = () => {
  return (
    <RequireAuth>
      <ProtectedShell>
        <ProfilePage />
      </ProtectedShell>
    </RequireAuth>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ImpersonationProvider>
          <StreamingProvider>
            <NotificationProvider>
              <AppProvider>
                <div className="app-shell">
                  <div className="app-main-content">
                    <Routes>
                      {/* Public auth routes */}
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                      <Route path="/verify-email" element={<VerifyEmailPage />} />
                      <Route path="/auth/callback" element={<AuthCallbackPage />} />

                      {/* Protected routes */}
                      <Route path="/profile" element={<ProtectedProfile />} />
                      <Route path="/*" element={<ProtectedContent />} />
                    </Routes>
                  </div>
                </div>
              </AppProvider>
            </NotificationProvider>
          </StreamingProvider>
        </ImpersonationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
